module.exports = __webpack_public_path__ + "img/scene1.27038d0e.webp";